import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="About Arjen Menu"
      items={[
        {
          name: 'about-us',
          title: 'About Arjen',
        },
        {
          name: 'our-buying-process',
          title: 'Our Buying Process',
        },
        {
          name: 'our-construction-process',
          title: 'Our Construction Process',
        },
        {
          name: 'luxury-features',
          title: 'Luxury Features',
        },
        {
          name: 'testimonials',
          title: 'Testimonials',
        },
        {
          name: 'blog',
          title: 'Arjen Home News',
          activeExact: false,
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuAbout.js